import { sumPotAccumulated } from './potPurposeUtils';
import { toNumber } from '../utils/number';

/**
 * @param {{ liquidEur?: number, pots?: object[] }} params
 */
export function computeTreasuryOverview({ liquidEur = 0, pots = [] } = {}) {
  const activePots = (pots || []).filter((pot) => !pot?.is_closed);
  const reservedEur = sumPotAccumulated(activePots);
  const liquid = Math.max(0, toNumber(liquidEur));
  const hasLiquidBaseline = liquid > 0;
  const freeEur = hasLiquidBaseline ? Math.max(0, liquid - reservedEur) : 0;
  const totalEur = hasLiquidBaseline ? liquid : reservedEur;
  const reservedPct =
    totalEur > 0 ? Math.min(100, Math.round((reservedEur / totalEur) * 100)) : 0;

  return {
    reservedEur,
    freeEur,
    totalEur,
    reservedPct,
    hasLiquidBaseline,
  };
}
